export default __webpack_public_path__ + "static/media/RomasFavorite.1691d12b.jpg";